<div>
  <div class="mb-3">
    <label class="form-label" for="asset-jobsite-location-id">
      {{ 'RegisterService::Jobsites' | abpLocalization }}
      <span *ngIf="isRequired" class="text-danger">*</span>
    </label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        [value]="
          editing
            ? asset.jobsiteNames.join(', ')
            : jobsiteNames.length
            ? jobsiteNames.join(', ')
            : ''
        "
        [readonly]="true"
      />
      <button *ngIf="!editing" class="btn btn-primary" (click)="openJobsitePicker()">
        {{ 'RegisterService::Pick' | abpLocalization }}
      </button>
      <button *ngIf="!editing" class="btn btn-danger" (click)="removeJobsites()">
        <i aria-hidden="true" class="fa fa-times"></i>
      </button>
    </div>
  </div>
</div>

<abp-modal [(visible)]="isJobsiteModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ 'RegisterService::Jobsites' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <app-locations-with-search
      [readonly]="true"
      (checkedKeysChange)="selectLocations($event)"
      [locationDefinition]="locationDefinition.JOBSITE"
      [displayHeaders]="false"
      [checkable]="true"
    >
    </app-locations-with-search>
  </ng-template>
  <ng-template #abpFooter>
    <button
      type="button"
      class="btn btn-primary"
      (click)="formatJobsiteNames()"
      [disabled]="checkedKeys.length === 0"
    >
      {{ 'AbpUi::Apply' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="onModalClose()">
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
